import { useEffect } from 'react'

export function useTitle(title) {
  useEffect(() => {
    const prevTitle = document.title
    document.title = title
    // restore the original title when component unmounts
    return () => {
      document.title = prevTitle
    }
  }, [title])
}
